<template>
	<ion-split-pane when="(min-width: 1400px)" content-id="main-content">
		<SideMenu />

		<!-- Slot for the router outlet content -->
		<slot />
	</ion-split-pane>

	<!-- Authenticated-only modals and UI components -->
	<LoginModal />
	<UserAgreementModal />
	<UserLocationEnable />
	<UserModal />
	<TaskRequestModal />
	<CreateNoteModal />
	<BatchAddPlantingsModal />
	<InstallPossibleModal ref="installModal" />
</template>

<script setup lang="ts">
	import { IonSplitPane } from "@ionic/vue";
	import UserModal from "@/components/feature/user/UserModal/UserModal.vue";
	import SideMenu from "@/views/SideMenu/SideMenu.vue";
	import LoginModal from "@/components/feature/auth/LoginModal.vue";
	import UserLocationEnable from "@/components/UserLocationEnable.vue";
	import InstallPossibleModal from "@/components/feature/pwa-install/InstallPossibleModal.vue";
	import UserAgreementModal from "@/components/feature/user/UserAgreementModal.vue";
	import TaskRequestModal from "@/components/feature/tasks/TaskRequestModal/TaskRequestModal.vue";
	import CreateNoteModal from "@/components/feature/notes/CreateNoteModal.vue";
	import BatchAddPlantingsModal from "@/components/ui/modals/BatchAddPlantingsModal.vue";
	import { provide, ref } from "vue";

	// PWA install modal functionality
	const installModal = ref();

	const showInstallModal = () => {
		installModal.value.show();
	};

	provide("showInstallModal", showInstallModal);
</script>

<style scoped>
	ion-split-pane {
		--side-max-width: 16rem;
		--side-min-width: 0;
	}
</style>
